import { render } from "./DashboardAccessPetitionView.vue?vue&type=template&id=65e03dbb"
import script from "./DashboardAccessPetitionView.vue?vue&type=script&lang=js"
export * from "./DashboardAccessPetitionView.vue?vue&type=script&lang=js"

import "./DashboardAccessPetitionView.vue?vue&type=style&index=0&id=65e03dbb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__